'use client';

import { PropsWithChildren } from 'react';

import { FormProvider, useForm } from 'react-hook-form';

import { useDistanceContext } from '@/hooks/use-distance-context';
import { usePagePropsAddressData } from '@/hooks/use-page-props-addressdata';
import { UseMyLocationFields } from '@xsf/shared-lib/hooks/location';

export type UMLFormProviderType = {
  providerField: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  latitude: string;
  longitude: string;
};

export const UseMyLocationFormProvider = ({ children }: PropsWithChildren): JSX.Element => {
  //  TODO: Investigate why UML is not setting default value
  const { location } = useDistanceContext();

  const addressData = usePagePropsAddressData();

  // if we have a location from OASapp context, use it to set default values in the form
  // otherwise, use distance location context (which might have a value from url params)
  // if none of them have a value, the form will be empty

  const address = location?.address || addressData?.address || '';
  const zipCode = location?.zip || addressData?.zip || '';
  const latitude = location?.latitude || addressData?.latitude || '';
  const longitude = location?.longitude || addressData?.longitude || '';

  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      providerField: '',
      [UseMyLocationFields.ADDRESS]: address,
      [UseMyLocationFields.CITY]: '',
      [UseMyLocationFields.STATE]: '',
      [UseMyLocationFields.ZIP_CODE]: zipCode,
      [UseMyLocationFields.LATITUDE]: latitude,
      [UseMyLocationFields.LONGITUDE]: longitude,
    },
  });

  return <FormProvider {...form}>{children}</FormProvider>;
};
